import React, { useState, useEffect } from 'react'
import './PromoBar.scss'

interface PromoBarProps {
  onVisibilityChange?: (isVisible: boolean) => void
}

const PromoBar: React.FC<PromoBarProps> = ({ onVisibilityChange }) => {
  const [isVisible, setIsVisible] = useState(true)

  const handleDismiss = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    setIsVisible(false)
  }

  useEffect(() => {
    onVisibilityChange?.(isVisible)
  }, [isVisible, onVisibilityChange])

  if (!isVisible) return null

  return (
    <div className="promo-bar">
      <a 
        href="https://apps.apple.com/us/app/check-in-app-by-peoplevine/id6470312773" 
        target="_blank" 
        rel="noopener noreferrer"
        className="promo-bar__link"
      >
        <div className="promo-bar__content">
          <span className="promo-bar__text">
            New Check-In App - Available Now - Click Here To Download
          </span>
        </div>
      </a>
      <button 
        onClick={handleDismiss}
        className="promo-bar__dismiss"
        aria-label="Dismiss promo bar"
      >
        ×
      </button>
    </div>
  )
}

export default PromoBar